export class GeneralResourcesApi {

    async pluckUfs() {
        try {
            const response = await axios.get('/estados/pluck');

            return response.data;
        } catch (error) {
            console.error('Error fetching ufs:', error);
            throw error;
        }
    }

    async pluckCities(uf) {
        try {
            const response = await axios.get(`/cidades/${uf}`);

            return response.data;
        } catch (error) {
            console.error('Error fetching cities:', error);
            throw error;
        }
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/api/GeneralResourcesApi.js